import React from "react"

import styles from "./CopyDetails.module.css"

const CopyDetails = ({ data }) => {
    return <div className={styles.ContentDetailsContainer}>
        <span className={styles.ContentDetailsHeader}>{data.copyName}</span>
        <p className={styles.ContentDescription}>{data.description}</p>
        <span className={styles.CreatedDate}>Created: {data.createdDate}</span>
    </div>
}

export default CopyDetails